import { toast } from "react-toastify";
import { fetchAddOfferFailure, fetchAddOfferSuccess } from "./reducer";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { ADD_OFFER_API } from "../../constants/constants";
import { setSuccessMessage } from "../../toastMessage/action";

function parseMultipleJsonObjects(str) {
  const regex = /{[^{}]*}/g; // matches each top-level {...} without nested braces
  const matches = str.match(regex);
  if (!matches) return [];

  return matches.map((m) => {
    try {
      return JSON.parse(m);
    } catch (e) {
      console.warn("Failed to parse chunk:", m, e);
      return null;
    }
  }).filter(Boolean);
}

export const registerOffer = (jsonObj, setLoading, navigate) => async (dispatch) => {
    setLoading(true)
    await determineBaseUrlAndPerformApiCall(`${ADD_OFFER_API}`, 'POST', jsonObj).then((response) => {
        if(typeof response === 'string' && response?.includes("error")){
            setLoading(false);
            const parsedObjects = parseMultipleJsonObjects(response);
            const errResponse = parsedObjects.length > 0 ? parsedObjects?.map(i => i?.message)?.join('\n') : "Invalid request."; 
            toast.error(errResponse)
            dispatch(fetchAddOfferFailure(response))
            return;
        }
        if (!response.error) {
            setLoading(false)
            dispatch(fetchAddOfferSuccess(response))
            navigate('/offer')
            dispatch(setSuccessMessage(true))
        }
        if (response.error) {
            setLoading(false)
            toast.error(`${response.error.message}`)
            dispatch(fetchAddOfferFailure(response.error.message))
        }
    }).catch((errorResp) => { })
}